import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-6 text-center">
      <h1 className="text-6xl md:text-8xl font-heading font-bold text-foreground-200 mb-4">404</h1>
      <p className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-3">
        Seite nicht gefunden
      </p>
      <p className="text-base text-foreground-500 mb-8 max-w-md">
        Die gesuchte Seite existiert leider nicht. Möglicherweise wurde sie verschoben oder gelöscht.
      </p>
      <Link
        to="/"
        className="px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
      >
        Zurück zur Startseite
      </Link>
    </div>
  );
}